import ChartBase from "./ChartBase";
import Chart from 'chart.js';
import { colors } from "./theme";
export class BarChart extends ChartBase {
    constructor() {
        super();
        this._init = () => {
            // always call this
            this._getElements();
        };
        this.updateData = (props) => {
            // get correct props
            var correctProps = props;
            // test combined props
            if (props.chartData) {
                correctProps = props.chartData;
            }
            // set metric and question
            this._setBaseInfo(props);
            // get data and labels
            let { data, rawData, backgroundColors, labels } = correctProps;
            //slice off the first colour because it is for "no-response"
            backgroundColors = backgroundColors.splice(1);
            // store data
            this.data = data;
            this.rawData = rawData;
            // update data if chart instance exist
            if (this.chart) {
                this.chart.data.datasets[0].data = data;
                // render
                this.chart.update();
            }
            // initiate chart instance
            else {
                this.chart = new Chart(this.ctx, {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                barPercentage: 1,
                                categoryPercentage: .9
                            }]
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [{
                                    gridLines: {
                                        display: false,
                                        color: colors.gridLineColor
                                    },
                                    ticks: {
                                        display: false,
                                        fontColor: colors.muted
                                    }
                                }
                            ],
                            yAxes: [{
                                    gridLines: {
                                        display: true,
                                        color: colors.gridLineColor
                                    },
                                    ticks: this._yTicksOption(),
                                },]
                        },
                        // generate custom legend html
                        legendCallback: function (chart) {
                            var legendHtml = [];
                            var metaData = chart.getDatasetMeta(0).data;
                            var data = chart.data.datasets[0].data;
                            for (var i = 0; i < data.length; i++) {
                                // create legend item
                                const div = document.createElement("div");
                                div.className = "legend-item";
                                div.setAttribute("data-id", i.toString());
                                // check if data is hidden
                                if (metaData[i].hidden == true) {
                                    div.classList.add("hidden");
                                }
                                // create legend
                                const spanLegend = document.createElement("span");
                                spanLegend.className = "legend-item-color";
                                spanLegend.style.backgroundColor = metaData[i]._model.backgroundColor;
                                // create legend text
                                const spanText = document.createElement("span");
                                spanText.className = "legend-item-text";
                                spanText.textContent = metaData[i]._model.label;
                                // add to legend item
                                div.appendChild(spanLegend);
                                div.appendChild(spanText);
                                legendHtml.push(div.outerHTML);
                            }
                            return legendHtml.join("");
                        },
                        tooltips: {
                            callbacks: {
                                label: (tooltipItem, data) => {
                                    // show raw data out of total
                                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                    if (label) {
                                        label += ':';
                                    }
                                    if (this.rawData) {
                                        const total = rawData.reduce(function (a, b) {
                                            return a + b;
                                        }, 0);
                                        label += ` ${this.rawData[tooltipItem.index]}/${total}`;
                                    }
                                    else {
                                        // default
                                        label += ` ${tooltipItem.value}`;
                                    }
                                    //console.log(tooltipItem);
                                    //console.log(this.rawData);
                                    //console.log(tooltipItem.index);
                                    //console.log(this.rawData[tooltipItem.index]);
                                    return label;
                                }
                            }
                        }
                    }
                });
                // generate legend
                this.legendElement.innerHTML = this.chart.generateLegend();
                // add legend filter event
                const legends = [].slice.call(this.legendElement.querySelectorAll(".legend-item"));
                legends.forEach(legendItem => {
                    legendItem.addEventListener("click", () => {
                        this._filterLegend(legendItem);
                    });
                });
            }
            // remove loading
            this.loading = false;
        };
        this._filterLegend = (legendItem) => {
            var _a, _b;
            const dataIndex = legendItem.getAttribute("data-id");
            const metaData = this.chart.getDatasetMeta(0).data;
            metaData[dataIndex].hidden = !metaData[dataIndex].hidden;
            // set status
            (_a = legendItem) === null || _a === void 0 ? void 0 : _a.classList.toggle("hidden", (_b = metaData[dataIndex]) === null || _b === void 0 ? void 0 : _b.hidden);
            // filter data
            const filteredData = metaData.map((meta, index) => meta.hidden ? 0 : this.data[index]);
            this.chart.data.datasets[0].data = filteredData;
            // render
            this.chart.update();
        };
        this._yTicksOption = () => {
            let options = {
                beginAtZero: true,
                fontColor: colors.muted
            };
            if (this.percentage) {
                options = Object.assign(Object.assign({}, options), { min: 0, max: 100, callback: function (value, index, values) {
                        if (value % 20 == 0) {
                            return value + "%";
                        }
                    } });
            }
            return options;
        };
    }
    get percentage() {
        return this.hasAttribute("percentage");
    }
    connectedCallback() {
        // html template
        this.innerHTML = `
            <div class="${this.class} dashboard-charts-item" data-wrapper>
                <div class="d-flex align-items-center mb-3">
                    <h6 class="text-uppercase font-weight-bold mb-0" data-metric></h6>
                    ${!!this.chartName ? `<div class="dashboard-charts-name">${this.chartName}</div>` : ''}
                </div>
                <p class="text-muted-light font-italic dashboard-charts-item-question" data-question></p>
                <div class="dashboard-charts-graph">
                    <canvas />
                </div>
                <div class="dashboard-charts-legend" data-legend>&nbsp; &nbsp;</div>
            </div>
        `;
        this._init();
    }
}
window.customElements.define("sva-bar-chart", BarChart);
